<template>
  <div class="page-not-found">
    <div class="flex flex-col justify-between">
      <p class="text-4xl font-extrabold text-yellow-600 sm:text-5xl">404</p>
      <h1
        class="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl pb-4"
        data-testid="page-not-found-title"
      >
        {{ $t("shared.modules.pageNotFound.views.pageNotFound.h1") }}
      </h1>
      <p class="mt-1 text-base text-gray-500">
        {{ $t("shared.modules.pageNotFound.views.pageNotFound.url") }}
      </p>
      <DsLink
        :to="{ name: 'Dashboard' }"
        theme-display="button"
        size="lg"
        class="ds-button-full mt-8"
      >
        {{ $t("common.button.home") }}
      </DsLink>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { DsLink } from "@devsalsa/vue-core";

/**
 * PageNotFound view
 * @version 1.0.0 - 2023-03-07
 */
export default defineComponent({
  name: "PageNotFound",
  components: {
    DsLink,
  },
});
</script>

<style lang="scss" scoped>
.page-not-found {
  main {
    margin-top: 64px;
    min-height: calc(100vh - 192px);
    @apply flex max-h-full justify-center items-center bg-white;

    @screen sm {
      min-height: calc(100vh - 128px);
    }
  }
}
</style>
